<template>
  <v-container fill-height justify-center v-if="progress">
    <div class="text-center">
      <v-progress-circular
        :rotate="2"
        :size="100"
        :width="10"
        color="primary"
        indeterminate
      >
      </v-progress-circular>
    </div>
  </v-container>
  <v-container fluid fill-height v-else>
    <v-layout justify-center row pa-4 v-if="items.length > 0">
      <v-flex xs12 sm10 md6>
        <v-flex class="mb-3" text-center>
          <h2>รายการพัสดุ</h2>
        </v-flex>
        <v-expansion-panels class="my-4">
          <v-expansion-panel v-for="(groupStatus, key) in groupsStatus">
            <v-expansion-panel-header
              v-if="key === 'S'"
              style="border-left:solid 5px #fbc02d;background: #f3f4f6;font-size: 14px;color: #0045AF">
              <v-flex justify="space-around" align="center">
                <b><span>พัสดุรอรับ / รอเข้าตู้ / อยู่ในตู้</span></b>
              </v-flex>
              <v-flex class="text-right">
                <v-avatar left class="yellow darken-2" style="color: #ffffff">
                  <b>{{ groupStatus.length }}</b>
                </v-avatar>
                <b><span class="ml-2" style="color: #000000">ชิ้น</span></b>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-header
              v-else-if="key === 'R'"
              style="border-left:solid 5px #4CAF50;background: #f3f4f6;color: #0045AF">
              <v-flex justify="space-around" align="center">
                <b><span>พัสดุรับแล้ว</span></b>
              </v-flex>
              <v-flex class="text-right">
                <v-avatar left class="green" style="color: #ffffff">
                  <b>{{ groupStatus.length }}</b>
                </v-avatar>
                <b><span class="ml-2" style="color: #000000">ชิ้น</span></b>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-header
              v-else-if="key === 'P'"
              style="border-left:solid 5px #F44336;background: #f3f4f6;color: #0045AF">
              <v-flex justify="space-around" align="center">
                <b><span>พัสดุส่งคืน</span></b>
              </v-flex>
              <v-flex class="text-right">
                <v-avatar left class="red" style="color: #ffffff">
                  <b>{{ groupStatus.length }}</b>
                </v-avatar>
                <b><span class="ml-2" style="color: #000000">ชิ้น</span></b>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="my-2 mt-4" v-for="(item, index) in groupStatus">
                <v-card class="mx-auto my-2"
                        @click="selectedParcel(groupStatus, index, item.SU_RUNNO)"
                        v-if="key === 'S' && (item.SU_STATUS === 'S' || item.SU_STATUS === 'W' || item.SU_STATUS === 'C')"
                        style="border-left:solid 5px #fbc02d;background: #f3f4f6">
                  <v-row>
                    <v-col class="text-center my-auto" cols="3">
                      <v-img class="ml-5" v-if="item.PATH" width="50" height="50" :src="item.PATH"></v-img>
                      <v-icon v-else large color="yellow darken-2">mdi-package-variant-closed</v-icon>
                      <br v-if="!item.PATH">
                      <span v-if="item.SU_STATUS === 'S'" class="overline font-weight-bold"
                            style="color: #0045AF">รอรับ</span>
                      <span v-else-if="item.SU_STATUS === 'W' || item.SU_STATUS === 'C'"
                            class="overline font-weight-bold"
                            style="color: #0045AF">รอเข้าตู้</span>
                      <span v-else-if="item.SU_STATUS === 'I'" class="overline font-weight-bold"
                            style="color: #0045AF">อยู่ในตู้</span>
                      <v-card-actions class="pt-0" v-if="item.PATH">
                        <v-spacer></v-spacer>
                        <v-btn text
                               color="#0045AF"
                               @click="showImg(item.PATH)">
                          ดูรูป
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-col>
                    <v-col cols="7">
                      <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                      <v-card-text style="color: #ff2e34; font-size: 18px">
                        เลขที่อ้างอิง : {{ item.SU_CODE }}
                      </v-card-text>
                      <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                      </v-card-text>
                      <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                      <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                      <v-card-text>
                        วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="2" class="text-center my-auto"
                           v-if="item.SU_STATUS === 'S' || item.SU_STATUS === 'W' || item.SU_STATUS === 'C'">
                      <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="mx-auto my-2"
                        v-if="key === 'S' && item.SU_STATUS === 'I'"
                        style="border-left:solid 5px #fbc02d;background: #f3f4f6">
                  <v-row>
                    <v-col class="text-center my-auto" cols="3">
                      <v-img class="ml-5" v-if="item.PATH" width="50" height="50" :src="item.PATH"></v-img>
                      <v-icon v-else large color="yellow darken-2">mdi-package-variant-closed</v-icon>
                      <br v-if="!item.PATH">
                      <span class="overline font-weight-bold"
                            style="color: #0045AF">อยู่ในตู้</span>
                      <v-card-actions class="pt-0" v-if="item.PATH">
                        <v-spacer></v-spacer>
                        <v-btn text
                               color="#0045AF"
                               @click="showImg(item.PATH)">
                          ดูรูป
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-col>
                    <v-col cols="7">
                      <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                      <v-card-text style="color: #ff2e34; font-size: 18px">
                        เลขที่อ้างอิง : {{ item.SU_CODE }}
                      </v-card-text>
                      <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                      </v-card-text>
                      <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                      <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                      <v-card-text>
                        วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="mx-auto my-2"
                        @click="selectedParcel(groupStatus, index, item.SU_RUNNO)"
                        v-else-if="key === 'S' && item.SU_STATUS === 'E'"
                        style="border-left:solid 5px #F44336;background: #f3f4f6">
                  <v-row>
                    <v-col class="text-center my-auto" cols="3">
                      <v-img class="ml-5" v-if="item.PATH" width="50" height="50" :src="item.PATH"></v-img>
                      <v-icon v-else large color="yellow darken-2">mdi-package-variant-closed</v-icon>
                      <br v-if="!item.PATH">
                      <span class="overline font-weight-bold"
                            style="color: #0045AF">เกินกำหนด</span>
                      <v-card-actions class="pt-0" v-if="item.PATH">
                        <v-spacer></v-spacer>
                        <v-btn text
                               color="#0045AF"
                               @click="showImg(item.PATH)">
                          ดูรูป
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-col>
                    <v-col cols="7">
                      <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                      <v-card-text style="color: #ff2e34; font-size: 18px">
                        เลขที่อ้างอิง : {{ item.SU_CODE }}
                      </v-card-text>
                      <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                      </v-card-text>
                      <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                      <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                      <v-card-text>
                        วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="2" class="text-center my-auto">
                      <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="mx-auto my-2"
                        @click="selectedParcel(groupStatus, index, item.SU_RUNNO)"
                        v-else-if="key === 'P'"
                        style="border-left:solid 5px #F44336;background: #f3f4f6">
                  <v-row>
                    <v-col class="text-center my-auto" cols="3">
                      <v-icon large color="red">mdi-package-variant-closed</v-icon>
                      <br>
                      <span class="overline font-weight-bold" style="color: #0045AF">ส่งคืน</span>
                    </v-col>
                    <v-col cols="7">
                      <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                      <v-card-text style="color: #ff2e34; font-size: 18px">
                        เลขที่อ้างอิง : {{ item.SU_CODE }}
                      </v-card-text>
                      <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                      </v-card-text>
                      <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                      <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                      <v-card-text>
                        วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="mx-auto my-2"
                        v-else-if="key === 'R'"
                        style="border-left:solid 5px #4CAF50;background: #f3f4f6">
                  <v-row>
                    <v-col class="text-center my-auto" cols="3">
                      <v-icon large color="green">mdi-package-variant-closed</v-icon>
                      <br>
                      <span class="overline font-weight-bold"
                            style="color: #0045AF">รับแล้ว</span>
                    </v-col>
                    <v-col cols="9">
                      <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                      <v-card-text style="color: #ff2e34; font-size: 18px">
                        เลขที่อ้างอิง : {{ item.SU_CODE }}
                      </v-card-text>
                      <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                      </v-card-text>
                      <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                      <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                      <v-card-text v-if="key === 'R'" style="color: #000">
                        วันที่จ่าย : {{ item.SU_RECIEVED_DATE }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div>
          <v-btn color="#1565C0"
                 block
                 large
                 dark
                 @click="dialog2 = true">
            ยืนยันรับพัสดุ ({{ itemSelected.length }})
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center row pa-5 v-else>
      <v-flex class="mb-3" text-center>
        <h2>ไม่มีรายการพัสดุ</h2>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">ไม่มีรายการที่เลือก</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="green darken-1"
                 text
                 @click="dialog = false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="290">
      <v-card>
        <v-card-title class="headline">รายการที่เลือก</v-card-title>
        <v-card class="mx-auto"
                max-width="400"
                tile
                v-for="(item, key) in itemSelectedShow">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="green darken-1"
                 text
                 @click="goto('receive')">
            ตกลง
          </v-btn>
          <v-btn color="red darken-1"
                 text
                 @click="dialog2 = false">
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogImg" max-width="700">
      <v-card>
        <v-card-title>
          <v-img :src="imageFile" aspect-ratio="0.6"></v-img>
        </v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="green darken-1"
                 text
                 @click="dialogImg = false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EventBus from '@/EventBus'
import axios from '@/axios';

export default {
  data() {
    return {
      searchData: {
        searchText: this.getLocalItem().searchText,
        nt_runno: this.getLocalItem().nt_runno
      },
      items: [],
      items2: [],
      itemSelected: [],
      itemSelectedShow: [],
      progress: true,
      dialog: false,
      dialog2: false,
      imageFile: '',
      dialogImg: false,
    }
  },
  computed: {
    groupsStatus() {
      console.log('groupsStatus', this.groupByData(this.items, 'GR_ST'))
      return this.groupByData(this.items, 'GR_ST')
    }
  },
  mounted() {
    let localItem = this.getLocalItem();

    if (localItem.searchText) {
      window.scrollTo(0, 0)
      EventBus.$emit('set_navigation', {title: 'พัสดุ', back_route: 'search-parcel'})
      if (localItem.searchText.toUpperCase().match('/INSTEAD')) {
        console.log('searchText', localItem.searchText.split('/')[0])
        this.searchData.searchText = localItem.searchText.split('/')[0]
        localItem.INSTEAD = 'Y'
      } else {
        localItem.INSTEAD = 'N'
      }

      delete localItem.itemSelected;
      delete localItem.QRref;
      localStorage.setItem('parcel', JSON.stringify(localItem))

      // if (localItem.itemsParcel) {
      //     this.items = localItem.itemsParcel
      //     this.progress = false
      // } else {
      this.listParcel()
      // }
    } else {
      this.$router.push({name: 'search-parcel'})
    }

  },
  methods: {
    goto(route_name, params) {
      if (route_name === 'receive' && this.itemSelected.length === 0) {
        this.dialog = true
      } else {
        let localItem = this.getLocalItem();
        localItem.itemSelected = this.itemSelected
        localStorage.setItem('parcel', JSON.stringify(localItem))

        return this.$router.push({name: route_name})
      }
    },
    async listParcel() {
      try {
        this.refreshToken().then((res) => {
          console.log('refreshToken')
          let localitem = this.getLocalItem()

          localitem.refreshToken = res.refreshToken
          localitem.token = res.jwt
          localitem.availableUntil = res.availableUntil

          localStorage.setItem('parcel', JSON.stringify(localitem));

          axios.post('/AllParcelList', this.searchData)
            .then(res => {
              // console.log('ParcelList', res)
              this.items = res.data.data
              let itemDefault = []
              let itemDefaultShow = []
              res.data.data.forEach(function (value) {
                if (value.SU_STATUS === 'S' || value.SU_STATUS === 'E' || value.SU_STATUS === 'W' || value.SU_STATUS === 'C') {
                  // console.log('items', value.SU_RUNNO)
                  itemDefault.push(value.SU_RUNNO)
                  itemDefaultShow.push(value.SU_CODE)
                }
              })
              this.itemSelected = itemDefault
              this.itemSelectedShow = itemDefaultShow
              // console.log('selectedParcel', this.itemSelected)

              this.progress = false
            })
        })
      } catch (err) {
        console.log(err.message)
      }
    },
    selectedParcel(array, index, data) {
      if (array[index].CLICK == '1') {
        array[index].CLICK = '0'
        this.removeItem(this.itemSelected, data)
        this.removeItem(this.itemSelectedShow, array[index].SU_CODE)
      } else {
        array[index].CLICK = '1'
        this.itemSelected.push(data)
        this.itemSelectedShow.push(array[index].SU_CODE)
      }
      // console.log('selectedParcel', this.itemSelected)
    },
    showImg(img) {
      this.imageFile = img
      this.dialogImg = true
    }
  }
}
</script>

<style>
.v-expansion-panel-content__wrap {
  padding: 0 6px 6px !important;
}

.v-card__title {
  padding: 0;
  font-size: 1em;
}

.v-card__text {
  padding: 0;
  color: #505a63;
  font-size: 12px;
}

.col-9, .col-7, .col-3, .col-2 {
  padding: 0;
}
</style>

